/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './exception-field.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i3 from '@angular/material';
import * as i4 from '@angular/cdk/platform';
import * as i5 from '@angular/cdk/overlay';
import * as i6 from '@angular/cdk/scrolling';
import * as i7 from '@angular/cdk/bidi';
import * as i8 from '@angular/common';
import * as i9 from '../../../../../../app/modules/fields/components/exception-field/exception-field.component';
const styles_ExceptionFieldComponent:any[] = [i0.styles];
export const RenderType_ExceptionFieldComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_ExceptionFieldComponent,data:{}});
function View_ExceptionFieldComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,16777216,(null as any),(null as any),10,'button',
      [['class','mat-icon-button'],['md-icon-button',''],['mdTooltip','Exception'],
          ['mdTooltipPosition','above']],[[8,'disabled',0]],[[(null as any),'click'],
          [(null as any),'longpress'],[(null as any),'touchend']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('longpress' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,4).show()) !== false);
          ad = (pd_0 && ad);
        }
        if (('touchend' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,4).hide(1500)) !== false);
          ad = (pd_1 && ad);
        }
        if (('click' === en)) {
          const pd_2:any = ((<any>_co.exceptionService()) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(1,16384,(null as any),
      0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(2,180224,(null as any),0,i3.MdButton,[i1.Renderer2,i1.ElementRef,
      i4.Platform,i3.FocusOriginMonitor],{disabled:[0,'disabled'],color:[1,'color']},
      (null as any)),i1.ɵdid(3,16384,(null as any),0,i3.MdIconButtonCssMatStyler,([] as any[]),
      (null as any),(null as any)),i1.ɵdid(4,147456,(null as any),0,i3.MdTooltip,[i5.Overlay,
      i1.ElementRef,i6.ScrollDispatcher,i1.ViewContainerRef,i1.NgZone,i1.Renderer2,
      i4.Platform,i3.MD_TOOLTIP_SCROLL_STRATEGY,[2,i7.Directionality]],{position:[0,
      'position'],message:[1,'message']},(null as any)),(_l()(),i1.ɵted(-1,0,['\n  '])),
      (_l()(),i1.ɵeld(6,0,(null as any),0,3,'md-icon',[['class','mat-icon'],['role',
          'img']],(null as any),(null as any),(null as any),i2.View_MdIcon_0,i2.RenderType_MdIcon)),
      i1.ɵdid(7,16384,(null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(8,638976,(null as any),
          0,i3.MdIcon,[i1.Renderer2,i1.ElementRef,i3.MdIconRegistry,[8,(null as any)]],
          (null as any),(null as any)),(_l()(),i1.ɵted(-1,0,['error_outline'])),(_l()(),
          i1.ɵted(-1,0,['\n'])),(_l()(),i1.ɵand(0,(null as any),(null as any),0))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_1:any = _co.disabled;
        const currVal_2:any = _co.color;
        _ck(_v,2,0,currVal_1,currVal_2);
        const currVal_3:any = 'above';
        const currVal_4:any = 'Exception';
        _ck(_v,4,0,currVal_3,currVal_4);
        _ck(_v,8,0);
      },(_ck,_v) => {
        const currVal_0:any = (i1.ɵnov(_v,2).disabled || (null as any));
        _ck(_v,0,0,currVal_0);
      });
}
export function View_ExceptionFieldComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_ExceptionFieldComponent_1)),i1.ɵdid(1,16384,(null as any),0,i8.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['\n']))],(_ck,_v) => {
    var _co:i9.ExceptionFieldComponent = _v.component;
    const currVal_0:any = _co.fieldValue;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_ExceptionFieldComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-exception-field',
      ([] as any[]),(null as any),(null as any),(null as any),View_ExceptionFieldComponent_0,
      RenderType_ExceptionFieldComponent)),i1.ɵdid(1,49152,(null as any),0,i9.ExceptionFieldComponent,
      [i3.MdDialog],(null as any),(null as any))],(null as any),(null as any));
}
export const ExceptionFieldComponentNgFactory:i1.ComponentFactory<i9.ExceptionFieldComponent> = i1.ɵccf('app-exception-field',
    i9.ExceptionFieldComponent,View_ExceptionFieldComponent_Host_0,{fieldValue:'fieldValue',
        disabled:'disabled'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL2ZpZWxkcy9jb21wb25lbnRzL2V4Y2VwdGlvbi1maWVsZC9leGNlcHRpb24tZmllbGQuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL2ZpZWxkcy9jb21wb25lbnRzL2V4Y2VwdGlvbi1maWVsZC9leGNlcHRpb24tZmllbGQuY29tcG9uZW50LnRzIiwibmc6Ly8vdmFyL3d3dy9kbmF0YS1jZXJmLWZyb250LWVuZC9yZWxlYXNlcy8yMDIwMDMyNjE2MTIzMy9zcmMvYXBwL21vZHVsZXMvZmllbGRzL2NvbXBvbmVudHMvZXhjZXB0aW9uLWZpZWxkL2V4Y2VwdGlvbi1maWVsZC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL2ZpZWxkcy9jb21wb25lbnRzL2V4Y2VwdGlvbi1maWVsZC9leGNlcHRpb24tZmllbGQuY29tcG9uZW50LnRzLkV4Y2VwdGlvbkZpZWxkQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGJ1dHRvbiAqbmdJZj1cImZpZWxkVmFsdWVcIiBtZC1pY29uLWJ1dHRvbiBbY29sb3JdPVwiY29sb3JcIiAoY2xpY2spPVwiZXhjZXB0aW9uU2VydmljZSgpXCIgIG1kVG9vbHRpcD1cIkV4Y2VwdGlvblwiIG1kVG9vbHRpcFBvc2l0aW9uPVwiYWJvdmVcIiBbZGlzYWJsZWRdPVwiZGlzYWJsZWRcIj5cbiAgPG1kLWljb24+ZXJyb3Jfb3V0bGluZTwvbWQtaWNvbj5cbjwvYnV0dG9uPlxuIiwiPGFwcC1leGNlcHRpb24tZmllbGQ+PC9hcHAtZXhjZXB0aW9uLWZpZWxkPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUEwRDtVQUFBO1VBQUE7UUFBQTtRQUExRDtNQUFBLHFEQUFBO01BQUE7TUFBQSxzQkFBQTt1Q0FBQTtNQUFBLHNCQUFBO01BQUEsb0NBQUE7O2dEQUFBO01BQUEsa0RBQThKO01BQzVKO1VBQUE7YUFBQTt1QkFBQSxzQ0FBQTtVQUFBO1VBQUEsNkJBQVMseUNBQXVCO2lCQUFBOzs7UUFEc0c7UUFBOUY7UUFBMUMsV0FBd0ksVUFBOUYsU0FBMUM7UUFBOEc7UUFBdEI7UUFBeEYsV0FBOEcsVUFBdEIsU0FBeEY7UUFDRTs7UUFERjtRQUFBLFdBQUEsU0FBQTs7OztvQkFBQTtNQUFBLHdDQUFBO29CQUFBLG1DQUVTO01BQUE7O0lBRkQ7SUFBUixXQUFRLFNBQVI7Ozs7b0JDQUE7TUFBQTt3Q0FBQSxVQUFBO01BQUE7Ozs7In0=



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/fields/components/exception-field/exception-field.component.ngfactory.ts